const colors = ['#33638D', '#54C667', '#9628d9', '#FF8900'];

function getRandomNumber(min: number, max: number, round: boolean = false) {
  let num = Math.random() * (max - min) + min;
  round && (num = Math.round(num));
  return num;
}

const fitIntoInterval = (num, lower, upper) => {
  let val = num;
  if (num < lower) {
    val = lower;
  } else if (num > upper) {
    val = upper;
  }
  return val;
};

const hoverTemplatePoint = 'x: %{x}<br>' + 'y: %{y}<br>' + '<extra></extra>';

const olsVsRidgeXTrain = [1.25, 1, 0.75, 1.5];
const olsVsRidgeXTest = [1.75, 1.5, 0.75];
const olsVsRidgeYTrain = [40, 42, 46, 37];
const olsVsRidgeYTest = [40, 38, 39.8];
const olsVsRidgeXInterval = [0, 0.5, 1, 1.5, 2, 2.5, 3.0];
const olsVsRidgeOlsPreds = [54.3, 48.5, 42.7, 36.9, 31.1, 25.3, 19.5];
const olsVsRidgeRidgePreds = [44.36, 42.98, 41.6, 40.21, 38.83, 37.45, 36.07];

const olsVsRidgeXStandardized = [0.098, -0.588, -1.275, 0.784, 1.471, 0.784, -1.275];

const olsVsRidgeTrainData = [
  {
    x: olsVsRidgeXTrain,
    y: olsVsRidgeYTrain,
    type: `scatter`,
    mode: 'markers',
    name: 'Train',
    showlegend: true,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[0],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
  {
    x: olsVsRidgeXTest,
    y: olsVsRidgeYTest,
    type: 'scatter',
    mode: 'markers',
    name: 'Test',
    showlegend: true,
    hoverlabel: {
      font: { color: '#000' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[1],
      line: {
        color: '#000',
        width: 0.5,
      },
    },
  },
];

const olsVsRidgeOlsPredsData = [
  {
    x: olsVsRidgeXInterval,
    y: olsVsRidgeOlsPreds,
    type: `scatter`,
    mode: 'lines',
    name: 'OLS',
    showlegend: true,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[2],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
];

const olsVsRidgeRidgePredsData = [
  {
    x: olsVsRidgeXInterval,
    y: olsVsRidgeRidgePreds,
    type: `scatter`,
    mode: 'lines',
    name: 'Better <br> Model',
    showlegend: true,
    hoverlabel: {
      font: { color: '#000' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[3],
      line: {
        color: '#000',
        width: 0.5,
      },
    },
  },
];

export const olsVsRidgeData = {
  data: [
    {
      x: olsVsRidgeXTrain.concat(olsVsRidgeXTest),
      y: olsVsRidgeYTrain.concat(olsVsRidgeYTest),
      type: `scatter`,
      mode: 'markers',
      name: 'train',
      showlegend: false,
      hoverlabel: {
        font: { color: '#fff' },
      },
      hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
      marker: {
        size: 15,
        color: colors[0],
        line: {
          color: '#fff',
          width: 0.5,
        },
      },
    },
  ],
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Prices',
    fixedRange: true,
  },
};

export const olsVsRidgeDataTrainTest = {
  data: olsVsRidgeTrainData,
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Prices | Train and Test',
    fixedRange: true,
  },
};

export const olsVsRidgeDataTrainTestOls = {
  data: olsVsRidgeTrainData.concat(olsVsRidgeOlsPredsData),
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Prices | OLS',
    fixedRange: true,
  },
};

export const olsVsRidgeDataTrainTestOlsRidge = {
  data: olsVsRidgeTrainData.concat(olsVsRidgeOlsPredsData, olsVsRidgeRidgePredsData),
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Prices | OLS vs. Better Model',
    fixedRange: true,
  },
};

const linregWiggleYTrain = [0.5, 1];
const linregWiggleXInterval = [0, 2];
const linregWiggleXTrainVariations = [
  [0.5, 1],
  [0.5, 0.9],
  [0.5, 1.1],
  [0.4, 1],
  [0.4, 0.9],
  [0.4, 1.1],
  [0.6, 1],
  [0.6, 0.9],
  [0.6, 1.1],
  [0.3, 0.9],
  [0.3, 1],
  [0.3, 1.1],
];

const linregWiggleVariationsOLSPreds = [
  [0, 2],
  [-0.13, 2.38],
  [0.08, 1.75],
  [0.17, 1.83],
  [0.1, 2.1],
  [0.21, 1.64],
  [-0.25, 2.25],
  [-0.5, 2.83],
  [-0.1, 1.9],
  [0.25, 1.92],
  [0.29, 1.71],
  [0.31, 1.56],
];

const linregWiggleVariationsRidgePreds = [
  [0.33, 1.44],
  [0.36, 1.47],
  [0.32, 1.39],
  [0.38, 1.45],
  [0.39, 1.5],
  [0.37, 1.38],
  [0.31, 1.42],
  [0.36, 1.4],
  [0.28, 1.39],
  [0.43, 1.5],
  [0.42, 1.43],
  [0.42, 1.37],
];

const linregWiggleVariationsLassoPreds = [
  [0.6, 1],
  [0.75, 0.75],
  [0.53, 1.08],
  [0.56, 1.11],
  [0.62, 1.02],
  [0.52, 1.13],
  [0.75, 0.75],
  [0.75, 0.75],
  [0.58, 0.98],
  [0.58, 1.14],
  [0.55, 1.16],
  [0.53, 1.16],
];

const wiggleLength = 11;

const wiggleDict = {
  ols: linregWiggleVariationsOLSPreds,
  ridge: linregWiggleVariationsRidgePreds,
  lasso: linregWiggleVariationsLassoPreds,
};

const wiggleLayout = {
  xaxis: {
    range: [0, 2],
    title: 'x',
    showgrid: true,
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  yaxis: {
    range: [0, 2],
    title: 'y',
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  margin: { t: 80, r: 80, b: 80, l: 80 },
  paper_bgcolor: `rgba(0, 0, 0, 0)`,
  plot_bgcolor: `rgba(0, 0, 0, 0)`,
  font: {
    color: `rgba(255,255,255,0.5)`,
    size: 16,
  },
};

const getChangeDataWiggle = wiggleKey => {
  const changeDataWiggle = data => {
    const currentPredsIdx = getRandomNumber(0, wiggleLength, true);

    let newWiggleData = getWiggleData(wiggleKey, currentPredsIdx);

    newWiggleData = [{ ...newWiggleData[0] }, { ...newWiggleData[1] }];

    data.forEach((_, idx) => {
      if (idx % 2 == 0) {
        data[idx].opacity = 0;
      } else {
        data[idx].opacity *= 0.6;
        data[idx].marker != null && (data[idx].marker.color = '#808080');
        data[idx].hovertemplate = '<extra></extra>';
      }
    });

    return newWiggleData.concat(data);
  };
  return changeDataWiggle;
};

const getWiggleData = (wiggleKey, wigglePredsIdx) => {
  const newWiggleData = [
    {
      x: linregWiggleXTrainVariations[wigglePredsIdx],
      y: linregWiggleYTrain,
      type: `scatter`,
      mode: 'markers',
      name: 'train',
      showlegend: false,
      opacity: 1,
      hoverlabel: {
        font: { color: '#fff' },
      },
      hovertemplate: 'hours studied: %{x}<br>' + 'points achieved: %{y}<br>' + '<extra></extra>',
      marker: {
        size: 15,
        color: colors[0],
        line: {
          color: '#fff',
          width: 0.5,
        },
      },
    },
    {
      x: linregWiggleXInterval,
      y: wiggleDict[wiggleKey][wigglePredsIdx],
      type: 'scatter',
      mode: 'lines',
      name: 'predictions',
      showlegend: false,
      opacity: 1,
      hoverlabel: {
        font: { color: '#fff' },
      },
      hovertemplate: 'hours studied: %{x}<br>' + 'points achieved: %{y}<br>' + '<extra></extra>',
      marker: {
        size: 15,
        color: colors[1],
        line: {
          color: '#fff',
          width: 0.5,
        },
      },
    },
  ];

  return newWiggleData;
};

const olsWiggleData = [
  {
    x: linregWiggleXTrainVariations[0],
    y: linregWiggleYTrain,
    type: `scatter`,
    mode: 'markers',
    name: 'train',
    opacity: 1,
    showlegend: false,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'hours studied: %{x}<br>' + 'points achieved: %{y}<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[0],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
  {
    x: linregWiggleXInterval,
    y: linregWiggleVariationsOLSPreds[0],
    type: 'scatter',
    mode: 'lines',
    opacity: 1,
    name: 'predictions',
    showlegend: false,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'hours studied: %{x}<br>' + 'points achieved: %{y}<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[1],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
];

const ridgeWiggleData = getWiggleData('ridge', 0);
const lassoWiggleData = getWiggleData('lasso', 0);

export const olsWiggle = {
  data: olsWiggleData,
  layout: wiggleLayout,
  props: {
    changeDataFunctions: { 'shift points': getChangeDataWiggle('ols') },
    fixedRange: true,
    plotTitle: 'OLS Sensitivity Visualized',
  },
};

export const ridgeWiggle = {
  data: ridgeWiggleData,
  layout: wiggleLayout,
  props: {
    changeDataFunctions: { 'shift points': getChangeDataWiggle('ridge') },
    fixedRange: true,
    plotTitle: 'Ridge Sensitivity Visualized',
  },
};

export const lassoWiggle = {
  data: lassoWiggleData,
  layout: wiggleLayout,
  props: {
    changeDataFunctions: { 'shift points': getChangeDataWiggle('lasso') },
    fixedRange: true,
    plotTitle: 'Lasso Sensitivity Visualized',
  },
};

const polyOlsRidgeX = [
  3.37, 8.56, 6.59, 5.39, 1.4, 1.4, 0.52, 7.8, 5.41, 6.37, 0.19, 8.73, 7.49, 1.91, 1.64, 1.65, 2.74,
  4.72, 3.89, 2.62, 5.51, 1.26, 2.63, 3.3, 4.1, 7.07, 1.8, 4.63, 5.33, 0.42, 5.47, 1.53, 0.59, 8.54,
  8.69, 7.28, 2.74, 0.88, 6.16, 3.96, 1.1, 4.46, 0.31, 8.18, 2.33, 5.96, 2.81, 4.68, 4.92, 1.66,
  1.25, 1, 0.75, 1.5, 1.75, 1.5, 0.75,
];

const polyOlsRidgeY = [
  22.75, 21.7, 20.85, 20.67, 21, 22.01, 22.99, 22.62, 21.53, 18.65, 24.29, 21.03, 20.23, 23.44,
  24.18, 24.04, 20.98, 20.81, 21.96, 23.47, 20.42, 22.83, 20.69, 20.2, 22.52, 22.87, 22.6, 22.59,
  21.57, 22.83, 21.54, 24.93, 23.51, 23.55, 18.03, 22.19, 22.22, 22.95, 21.12, 18.84, 22.89, 21.78,
  25.74, 20.64, 21.27, 20.34, 23.28, 21.68, 20.47, 23.47, 20, 21, 23, 18.5, 20, 18.5, 19.9,
];

const polyOlsRidgeXInterval = [
  0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2,
  2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.9, 3, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4,
  4.1, 4.2, 4.3, 4.4, 4.5, 4.6, 4.7, 4.8, 4.9, 5, 5.1, 5.2, 5.3, 5.4, 5.5, 5.6, 5.7, 5.8, 5.9, 6,
  6.1, 6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 7, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.8, 7.9, 8,
  8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9,
];

const polyOlsPreds = [
  25.91, 25.2, 24.58, 24.04, 23.58, 23.19, 22.86, 22.59, 22.36, 22.19, 22.05, 21.94, 21.87, 21.82,
  21.79, 21.78, 21.79, 21.8, 21.83, 21.86, 21.9, 21.93, 21.97, 22.01, 22.04, 22.07, 22.1, 22.11,
  22.13, 22.13, 22.13, 22.12, 22.1, 22.07, 22.04, 22, 21.95, 21.9, 21.84, 21.77, 21.7, 21.63, 21.56,
  21.48, 21.4, 21.32, 21.25, 21.17, 21.1, 21.03, 20.97, 20.91, 20.86, 20.81, 20.77, 20.74, 20.72,
  20.71, 20.71, 20.71, 20.73, 20.76, 20.8, 20.84, 20.9, 20.96, 21.03, 21.11, 21.19, 21.28, 21.37,
  21.46, 21.55, 21.64, 21.72, 21.79, 21.85, 21.9, 21.92, 21.93, 21.9, 21.85, 21.76, 21.63, 21.46,
  21.23, 20.95, 20.6, 20.18, 19.68, 19.09,
];

const polyRidgePreds = [
  23.3, 23.18, 23.08, 22.98, 22.88, 22.8, 22.72, 22.65, 22.58, 22.52, 22.46, 22.41, 22.36, 22.31,
  22.26, 22.22, 22.18, 22.14, 22.09, 22.05, 22.02, 21.98, 21.94, 21.9, 21.86, 21.83, 21.79, 21.75,
  21.72, 21.68, 21.64, 21.6, 21.57, 21.53, 21.5, 21.46, 21.43, 21.4, 21.36, 21.33, 21.3, 21.27,
  21.25, 21.22, 21.2, 21.17, 21.15, 21.13, 21.12, 21.11, 21.09, 21.08, 21.08, 21.07, 21.07, 21.07,
  21.08, 21.08, 21.09, 21.1, 21.11, 21.13, 21.14, 21.16, 21.18, 21.2, 21.22, 21.25, 21.27, 21.29,
  21.31, 21.33, 21.35, 21.37, 21.38, 21.39, 21.39, 21.4, 21.39, 21.38, 21.36, 21.33, 21.29, 21.25,
  21.19, 21.11, 21.02, 20.92, 20.8, 20.66, 20.51,
];

const polyOlsPredsDegreeTwo = [
  23.13, 23.06, 23, 22.93, 22.87, 22.81, 22.75, 22.69, 22.63, 22.58, 22.52, 22.46, 22.41, 22.36,
  22.31, 22.26, 22.21, 22.16, 22.11, 22.06, 22.02, 21.97, 21.93, 21.89, 21.84, 21.8, 21.76, 21.73,
  21.69, 21.65, 21.62, 21.58, 21.55, 21.52, 21.48, 21.45, 21.43, 21.4, 21.37, 21.34, 21.32, 21.29,
  21.27, 21.25, 21.23, 21.21, 21.19, 21.17, 21.15, 21.14, 21.12, 21.11, 21.1, 21.09, 21.07, 21.07,
  21.06, 21.05, 21.04, 21.04, 21.03, 21.03, 21.03, 21.02, 21.02, 21.02, 21.03, 21.03, 21.03, 21.04,
  21.04, 21.05, 21.06, 21.07, 21.08, 21.09, 21.1, 21.11, 21.13, 21.14, 21.16, 21.17, 21.19, 21.21,
  21.23, 21.25, 21.28, 21.3, 21.32, 21.35, 21.37,
];

const polyRidgePredsDegreeTwo = [
  23.05, 22.99, 22.93, 22.87, 22.82, 22.76, 22.7, 22.65, 22.59, 22.54, 22.49, 22.44, 22.39, 22.34,
  22.29, 22.24, 22.2, 22.15, 22.11, 22.06, 22.02, 21.98, 21.94, 21.9, 21.86, 21.82, 21.78, 21.75,
  21.71, 21.68, 21.64, 21.61, 21.58, 21.55, 21.52, 21.49, 21.46, 21.43, 21.41, 21.38, 21.36, 21.33,
  21.31, 21.29, 21.27, 21.25, 21.23, 21.21, 21.2, 21.18, 21.16, 21.15, 21.14, 21.12, 21.11, 21.1,
  21.09, 21.08, 21.08, 21.07, 21.06, 21.06, 21.05, 21.05, 21.05, 21.05, 21.05, 21.05, 21.05, 21.05,
  21.05, 21.06, 21.06, 21.07, 21.07, 21.08, 21.09, 21.1, 21.11, 21.12, 21.13, 21.15, 21.16, 21.18,
  21.19, 21.21, 21.23, 21.25, 21.27, 21.29, 21.31,
];

const polyOlsRidgeData = [
  {
    x: polyOlsRidgeX,
    y: polyOlsRidgeY,
    type: `scatter`,
    mode: 'markers',
    opacity: 1,
    showlegend: false,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[0],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
];

const polyOlsRidgePredsData = (useDegreeTwo: boolean) => [
  {
    x: polyOlsRidgeXInterval,
    y: useDegreeTwo ? polyOlsPredsDegreeTwo : polyOlsPreds,
    type: `scatter`,
    mode: 'lines',
    name: 'OLS',
    opacity: 1,
    showlegend: true,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[1],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
  {
    x: polyOlsRidgeXInterval,
    y: useDegreeTwo ? polyRidgePredsDegreeTwo : polyRidgePreds,
    type: `scatter`,
    mode: 'lines',
    name: 'Ridge',
    opacity: 1,
    showlegend: true,
    hoverlabel: {
      font: { color: '#fff' },
    },
    hovertemplate: 'age: %{x}y<br>' + 'price: %{y}€<br>' + '<extra></extra>',
    marker: {
      size: 15,
      color: colors[2],
      line: {
        color: '#fff',
        width: 0.5,
      },
    },
  },
];

export const polyOlsRidge = {
  data: polyOlsRidgeData,
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Prices 2',
    fixedRange: true,
  },
};

export const polyOlsRidgePreds = {
  data: polyOlsRidgeData.concat(polyOlsRidgePredsData(false)),
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Prices 2 Polynomial Predictions (degree=5)',
    fixedRange: true,
  },
};

export const polyOlsRidgePredsDegreeTwo = {
  data: polyOlsRidgeData.concat(polyOlsRidgePredsData(true)),
  props: {
    yAxisTitle: 'price (€)',
    xAxisTitle: 'age (years)',
    plotTitle: 'Figure Pricess 2 Polynomial Predictions (degree=2)',
    fixedRange: true,
  },
};

const iterationIdx = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900,
  1000,
];
const iterationIdxCD = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const thetaHistRidge = [
  [-75, -10],
  [-67.35, -1.4],
  [-60.74, 5.99],
  [-55.02, 12.33],
  [-50.08, 17.78],
  [-45.8, 22.46],
  [-42.09, 26.47],
  [-38.88, 29.91],
  [-36.09, 32.85],
  [-33.67, 35.37],
  [-31.56, 37.52],
  [-24.42, 44.33],
  [-20.65, 47.23],
  [-18.48, 48.28],
  [-13.67, 46.71],
  [-7.07, 41.11],
  [4.22, 31.41],
  [13.42, 23.5],
  [20.94, 17.05],
  [27.07, 11.79],
  [32.07, 7.49],
  [36.15, 3.98],
  [39.48, 1.12],
  [42.2, -1.21],
  [44.42, -3.11],
];
let thetaHistRidgeLoss = [
  16257.2, 12147.54, 9097.78, 6834.49, 5154.76, 3908.04, 2982.63, 2295.62, 1785.53, 1406.7, 1125.27,
  494.39, 347.63, 309.87, 271.65, 221.69, 147.69, 98.43, 65.65, 43.84, 29.32, 19.66, 13.23, 8.96,
  6.11,
];
thetaHistRidgeLoss = thetaHistRidgeLoss.map(v => v + 1000);

let thetaHistLassoSubGD = [
  [-75, -10],
  [-72.62, -10.39],
  [-70.3, -10.76],
  [-68.02, -11.12],
  [-65.79, -11.46],
  [-63.6, -11.79],
  [-61.46, -12.1],
  [-59.37, -12.39],
  [-57.32, -12.68],
  [-55.31, -12.94],
  [-53.34, -13.2],
  [-44.09, -14.29],
  [-35.76, -15.1],
  [-28.24, -15.66],
  [-0.27, -15.92],
  [20.91, -11.55],
  [32.96, -3.5],
  [35.62, -0.09],
  [36.15, -0.16],
  [36.22, -0.12],
  [36.23, -0.06],
  [36.23, 0.0],
  [36.23, -0.14],
  [36.23, -0.08],
  [36.23, -0.01],
];
let thetaHistLassoLossSubGD = [
  13054.93, 12499.27, 11967.57, 11458.78, 10971.9, 10505.97, 10060.07, 9633.34, 9224.93, 8834.04,
  8459.92, 6816.25, 5494.72, 4431.24, 1511.74, 370.87, 92.18, 77.41, 71.81, 71.45, 71.73, 72.12,
  71.23, 71.62, 72.03,
];
thetaHistLassoLossSubGD = thetaHistLassoLossSubGD.map(v => v + 1000);

let thetaHistLassoCD = [
  [-75.0, -10.0],
  [37.55, -10.0],
  [37.55, -3.31],
  [39.19, -3.31],
  [39.19, -2.69],
  [39.34, -2.69],
  [39.34, -2.63],
  [39.36, -2.63],
  [39.36, -2.62],
  [39.36, -2.62],
  [39.36, -2.62],
];
let thetaHistLassoLossCD = [
  13054.93, 68.93, 49.88, 44.73, 45.41, 45.16, 45.24, 45.22, 45.23, 45.23, 45.23,
];
thetaHistLassoLossCD = thetaHistLassoLossCD.map(v => v + 1000);

const lassoRidgeM = [
  -75.0, -74.0, -73.0, -72.0, -71.0, -70.0, -69.0, -68.0, -67.0, -66.0, -65.0, -64.0, -63.0, -62.0,
  -61.0, -60.0, -59.0, -58.0, -57.0, -56.0, -55.0, -54.0, -53.0, -52.0, -51.0, -50.0, -49.0, -48.0,
  -47.0, -46.0, -45.0, -44.0, -43.0, -42.0, -41.0, -40.0, -39.0, -38.0, -37.0, -36.0, -35.0, -34.0,
  -33.0, -32.0, -31.0, -30.0, -29.0, -28.0, -27.0, -26.0, -25.0, -24.0, -23.0, -22.0, -21.0, -20.0,
  -19.0, -18.0, -17.0, -16.0, -15.0, -14.0, -13.0, -12.0, -11.0, -10.0, -9.0, -8.0, -7.0, -6.0,
  -5.0, -4.0, -3.0, -2.0, -1.0, 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0,
  13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0, 25.0, 26.0, 27.0, 28.0,
  29.0, 30.0, 31.0, 32.0, 33.0, 34.0, 35.0, 36.0, 37.0, 38.0, 39.0, 40.0, 41.0, 42.0, 43.0, 44.0,
  45.0, 46.0, 47.0, 48.0, 49.0, 50.0, 51.0, 52.0, 53.0, 54.0, 55.0, 56.0, 57.0, 58.0, 59.0, 60.0,
  61.0, 62.0, 63.0, 64.0, 65.0, 66.0, 67.0, 68.0, 69.0, 70.0, 71.0, 72.0, 73.0, 74.0, 75.0,
];
const lassoRidgeB = [
  -75.0, -74.0, -73.0, -72.0, -71.0, -70.0, -69.0, -68.0, -67.0, -66.0, -65.0, -64.0, -63.0, -62.0,
  -61.0, -60.0, -59.0, -58.0, -57.0, -56.0, -55.0, -54.0, -53.0, -52.0, -51.0, -50.0, -49.0, -48.0,
  -47.0, -46.0, -45.0, -44.0, -43.0, -42.0, -41.0, -40.0, -39.0, -38.0, -37.0, -36.0, -35.0, -34.0,
  -33.0, -32.0, -31.0, -30.0, -29.0, -28.0, -27.0, -26.0, -25.0, -24.0, -23.0, -22.0, -21.0, -20.0,
  -19.0, -18.0, -17.0, -16.0, -15.0, -14.0, -13.0, -12.0, -11.0, -10.0, -9.0, -8.0, -7.0, -6.0,
  -5.0, -4.0, -3.0, -2.0, -1.0, 0.0, 1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 12.0,
  13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0, 25.0, 26.0, 27.0, 28.0,
  29.0, 30.0, 31.0, 32.0, 33.0, 34.0, 35.0, 36.0, 37.0, 38.0, 39.0, 40.0, 41.0, 42.0, 43.0, 44.0,
  45.0, 46.0, 47.0, 48.0, 49.0, 50.0, 51.0, 52.0, 53.0, 54.0, 55.0, 56.0, 57.0, 58.0, 59.0, 60.0,
  61.0, 62.0, 63.0, 64.0, 65.0, 66.0, 67.0, 68.0, 69.0, 70.0, 71.0, 72.0, 73.0, 74.0, 75.0,
];
//const ridgeLossZ = [16314.1, 10918.01, 7392.21, 5078.59, 3552.52, 2539.57, 1862.1, 1404.87, 1092.95, 877.49, 726.5, 618.97, 541.01, 483.39, 439.93, 406.46, 380.14, 359.0, 341.7, 327.26, 315.01, 304.44, 295.2, 287.01, 279.68, 273.04, 266.99, 261.42, 256.26, 251.47, 246.98, 242.77, 238.79, 235.04, 231.48, 228.1, 224.88, 221.82, 218.89, 216.1, 213.42, 210.86, 208.41, 206.05, 203.8, 201.63, 199.55, 197.55, 195.63, 193.79, 192.02, 190.31, 188.67, 187.09, 185.57, 184.11, 182.7, 181.34, 180.04, 178.78, 177.57, 176.4, 175.28, 174.19, 173.15, 172.14, 171.16, 170.23, 169.32, 168.45, 167.61, 166.8, 166.01, 165.26, 164.53, 163.82, 163.14, 162.48, 161.85, 161.23, 160.64, 160.07, 159.52, 158.98, 158.46, 157.97, 157.48, 157.02, 156.57, 156.13, 155.71, 155.3, 154.91, 154.53, 154.16, 153.8, 153.46, 153.12, 152.8, 152.49, 152.18, 151.89, 151.61, 151.33, 151.07, 150.81, 150.56, 150.32, 150.09, 149.86, 149.65, 149.43, 149.23, 149.03, 148.84, 148.65, 148.47, 148.3, 148.13, 147.97, 147.81, 147.65, 147.5, 147.36, 147.22, 147.09, 146.95, 146.83, 146.7, 146.58, 146.47, 146.36, 146.25, 146.14, 146.04, 145.94, 145.85, 145.75, 145.66, 145.58, 145.49, 145.41, 145.33, 145.25, 145.18, 145.11, 145.04, 144.97, 144.9, 144.84, 144.78, 144.72, 144.66, 144.6, 144.55, 144.49, 144.44, 144.39, 144.35, 144.3, 144.25, 144.21, 144.17, 144.12, 144.08, 144.05, 144.01, 143.97, 143.94, 143.9, 143.87, 143.84, 143.8, 143.77, 143.74, 143.72, 143.69, 143.66, 143.63, 143.61, 143.58, 143.56, 143.54, 143.52, 143.49, 143.47, 143.45, 143.43, 143.41, 143.39, 143.38, 143.36, 143.34, 143.33, 143.31, 143.29, 143.28, 143.26, 143.25, 143.24, 143.22, 143.21, 143.2, 143.19, 143.17, 143.16, 143.15, 143.14, 143.13, 143.12, 143.11, 143.1, 143.09, 143.08, 143.07, 143.07, 143.06, 143.05, 143.04, 143.03, 143.03, 143.02, 143.01, 143.01, 143.0, 142.99, 142.99, 142.98, 142.98, 142.97, 142.97, 142.96, 142.96, 142.95, 142.95, 142.94, 142.94, 142.93, 142.93, 142.92, 142.92, 142.92, 142.91, 142.91, 142.91, 142.9, 142.9, 142.9, 142.89, 142.89, 142.89, 142.88, 142.88, 142.88, 142.88, 142.87, 142.87, 142.87, 142.87, 142.86, 142.86, 142.86, 142.86, 142.86, 142.85, 142.85, 142.85, 142.85, 142.85, 142.85, 142.84, 142.84, 142.84, 142.84, 142.84, 142.84, 142.84, 142.83, 142.83, 142.83, 142.83, 142.83, 142.83, 142.83, 142.83, 142.83, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.82, 142.81, 142.81]
//const lassoLossZ = [16323.43, 11457.74, 8099.51, 5783.49, 4174.98, 3056.42, 2277.4, 1733.87, 1353.84, 1087.45, 900.17, 768.04, 674.43, 607.8, 560.11, 525.76, 500.83, 482.59, 469.12, 459.06, 451.47, 445.68, 441.18, 437.65, 434.84, 432.56, 430.68, 429.12, 427.78, 426.63, 425.63, 424.73, 423.92, 423.19, 422.51, 421.88, 421.28, 420.72, 420.17, 419.65, 419.15, 418.66, 418.18, 417.71, 417.24, 416.79, 416.33, 415.89, 415.44, 415.0, 414.56, 414.13, 413.69, 413.26, 412.83, 412.4, 411.97, 411.54, 411.12, 410.69, 410.26, 409.84, 409.41, 408.99, 408.56, 408.14, 407.72, 407.29, 406.87, 406.45, 406.02, 405.6, 405.18, 404.76, 404.33, 403.91, 403.49, 403.07, 402.65, 402.23, 401.81, 401.39, 400.97, 400.55, 400.13, 399.71, 399.29, 398.87, 398.45, 398.03, 397.61, 397.2, 396.78, 396.36, 395.94, 395.52, 395.11, 394.69, 394.27, 393.85, 393.44, 393.02, 392.61, 392.19, 391.77, 391.36, 390.94, 390.53, 390.11, 389.7, 389.28, 388.87, 388.45, 388.04, 387.62, 387.21, 386.8, 386.38, 385.97, 385.56, 385.15, 384.73, 384.32, 383.91, 383.5, 383.08, 382.67, 382.26, 381.85, 381.44, 381.03, 380.62, 380.21, 379.8, 379.39, 378.98, 378.57, 378.16, 377.75, 377.34, 376.93, 376.52, 376.11, 375.7, 375.3, 374.89, 374.48, 374.07, 373.66, 373.26, 372.85, 372.44, 372.04, 371.63, 371.22, 370.82, 370.41, 370.01, 369.6, 369.2, 368.79, 368.39, 367.98, 367.58, 367.17, 366.77, 366.36, 365.96, 365.56, 365.15, 364.75, 364.35, 363.94, 363.54, 363.14, 362.74, 362.34, 361.93, 361.53, 361.13, 360.73, 360.33, 359.93, 359.53, 359.13, 358.73, 358.33, 357.93, 357.53, 357.13, 356.73, 356.33, 355.93, 355.53, 355.13, 354.73, 354.34, 353.94, 353.54, 353.14, 352.74, 352.35, 351.95, 351.55, 351.16, 350.76, 350.36, 349.97, 349.57, 349.18, 348.78, 348.39, 347.99, 347.6, 347.2, 346.81, 346.41, 346.02, 345.62, 345.23, 344.84, 344.44, 344.05, 343.66, 343.27, 342.87, 342.48, 342.09, 341.7, 341.3, 340.91, 340.52, 340.13, 339.74, 339.35, 338.96, 338.57, 338.18, 337.79, 337.4, 337.01, 336.62, 336.23, 335.84, 335.45, 335.06, 334.67, 334.29, 333.9, 333.51, 333.12, 332.73, 332.35, 331.96, 331.57, 331.19, 330.8, 330.41, 330.03, 329.64, 329.25, 328.87, 328.48, 328.1, 327.71, 327.33, 326.94, 326.56, 326.17, 325.79, 325.41, 325.02, 324.64, 324.26, 323.87, 323.49, 323.11, 322.73, 322.34, 321.96, 321.58, 321.2, 320.82, 320.43, 320.05, 319.67, 319.29, 318.91, 318.53, 318.15, 317.77, 317.39, 317.01, 316.63, 316.25, 315.87, 315.49, 315.11, 314.74, 314.36, 313.98]

function f(m: number, b: number, i: number) {
  return m * i + b;
}

function mseRidge(points: number[], preds: number[], m: number, b: number, a: number = 0.0001) {
  let result = 0;
  for (let i = 0; i < points.length; i++) {
    let curPoint = points[i];
    let curPred = preds[i];
    result += (curPred - curPoint) ** 2;
  }
  result = result / points.length;
  result += a * m ** 2;
  result += a * b ** 2;
  return result;
}

function mseLasso(points: number[], preds: number[], m: number, b: number, a: number = 0.0001) {
  let result = 0;
  for (let i = 0; i < points.length; i++) {
    let curPoint = points[i];
    let curPred = preds[i];
    result += (curPred - curPoint) ** 2;
  }
  result = result / points.length;
  result += a * Math.abs(m);
  result += a * Math.abs(b);
  return result;
}

function getZRidge(m: number, b: number, points_x: number[], points_y: number[]) {
  let f_values = points_x.map(x => f(m, b, x));

  let z = mseRidge(points_y, f_values, m, b);

  return z;
}

function getZLasso(m: number, b: number, points_x: number[], points_y: number[]) {
  let f_values = points_x.map(x => f(m, b, x));

  let z = mseLasso(points_y, f_values, m, b);

  return z;
}

const lassoRidgeX = olsVsRidgeXTrain.concat(olsVsRidgeXTest);
const lassoRidgeY = olsVsRidgeYTrain.concat(olsVsRidgeYTest);

const ridgeLossZ = lassoRidgeB.map(curB =>
  lassoRidgeM.map(curM => getZRidge(curM, curB, lassoRidgeX, lassoRidgeY)),
);
const lassoLossZ = lassoRidgeB.map(curB =>
  lassoRidgeM.map(curM => getZLasso(curM, curB, olsVsRidgeXStandardized, lassoRidgeY)),
);

let currentLassoStepSubGD = 0;
let currentLassoStepCD = 0;
let currentRidgeStep = 0;

let currentLassoStepIncrementSize = 1;
let currentRidgeStepIncrementSize = 1;

const getCurrentLassoStepSubGD = () => iterationIdx[currentLassoStepSubGD];
const getCurrentLassoStepCD = () => iterationIdxCD[currentLassoStepCD];
const getCurrentRidgeStep = () => iterationIdx[currentRidgeStep];

const getCurrentStepAdjuster = (modelType, increment) => {
  const descentStepIterator = data => {
    if (increment == true) {
      if (modelType == 'Ridge') {
        if (currentRidgeStep == iterationIdx.length - 1) {
          currentRidgeStep = 0;
        } else {
          currentRidgeStep += 1;
        }
      } else if (modelType == 'LassoSubGD') {
        if (currentLassoStepSubGD == iterationIdx.length - 1) {
          currentLassoStepSubGD = 0;
        } else {
          currentLassoStepSubGD += 1;
        }
      } else {
        if (currentLassoStepCD == iterationIdxCD.length - 1) {
          currentLassoStepCD = 0;
        } else {
          currentLassoStepCD += 1;
        }
      }
    } else {
      if (modelType == 'Ridge') {
        if (currentRidgeStep == 0) {
          currentRidgeStep = iterationIdx.length - 1;
        } else {
          currentRidgeStep -= 1;
        }
      } else if (modelType == 'LassoSubGD') {
        if (currentLassoStepSubGD == 0) {
          currentLassoStepSubGD = iterationIdx.length - 1;
        } else {
          currentLassoStepSubGD -= 1;
        }
      } else {
        if (currentLassoStepCD == 0) {
          currentLassoStepCD = iterationIdxCD.length - 1;
        } else {
          currentLassoStepCD -= 1;
        }
      }
    }

    let newDataPoint: number[];
    let newDataPointLoss: number;
    if (modelType == 'Ridge') {
      newDataPoint = thetaHistRidge[currentRidgeStep];
      newDataPointLoss = thetaHistRidgeLoss[currentRidgeStep];
    } else if (modelType == 'LassoSubGD') {
      newDataPoint = thetaHistLassoSubGD[currentLassoStepSubGD];
      newDataPointLoss = thetaHistLassoLossSubGD[currentLassoStepSubGD];
    } else {
      newDataPoint = thetaHistLassoCD[currentLassoStepCD];
      newDataPointLoss = thetaHistLassoLossCD[currentLassoStepCD];
    }

    let currentStep =
      modelType == 'Ridge'
        ? currentRidgeStep
        : modelType == 'LassoSubGD'
        ? currentLassoStepSubGD
        : currentLassoStepCD;
    let currentDataPoints =
      modelType == 'Ridge'
        ? thetaHistRidge
        : modelType == 'LassoSubGD'
        ? thetaHistLassoSubGD
        : thetaHistLassoCD;
    let currentLoss =
      modelType == 'Ridge'
        ? thetaHistRidgeLoss
        : modelType == 'LassoSubGD'
        ? thetaHistLassoLossSubGD
        : thetaHistLassoLossCD;
    let iterationsList =
      modelType == 'Ridge' || modelType == 'LassoSubGD' ? iterationIdx : iterationIdxCD;
    let newX;
    let newY;
    let newZ;
    if (increment) {
      if (currentStep == 0) {
        newX = [currentDataPoints[0][1]];
        newY = [currentDataPoints[0][0]];
        newZ = [currentLoss[0]];
      } else {
        newX = data[1].x.concat(newDataPoint[1]);
        newY = data[1].y.concat(newDataPoint[0]);
        newZ = data[1].z.concat(newDataPointLoss);
      }
    } else {
      if (currentStep == iterationsList.length - 1) {
        newX = currentDataPoints.map(x => x[1]);
        newY = currentDataPoints.map(x => x[0]);
        newZ = currentLoss;
      } else {
        newX = data[1].x.slice(0, currentStep + 1);
        newY = data[1].y.slice(0, currentStep + 1);
        newZ = data[1].z.slice(0, currentStep + 1);
      }
    }

    return [
      data[0],
      { ...data[1], x: newX, y: newY, z: newZ },
      {
        ...data[2],
        x: [newDataPoint[1]],
        y: [newDataPoint[0]],
        z: [newDataPointLoss],
        text: [(newDataPointLoss - 1000).toFixed(2)],
      },
    ];
  };
  return descentStepIterator;
};

const ridgeHist3dData = [
  {
    x: lassoRidgeM,
    y: lassoRidgeB,
    z: ridgeLossZ,
    hoverlabel: {
      font: { color: '#fff' },
      bgcolor: '#17225D',
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Ridge-MSE: %{z}<br>' + '<extra></extra>',
    colorscale: 'YlGnBu',
    type: `surface`,
    contours: {
      z: {
        show: true,
        usecolormap: true,
        highlightcolor: `white`,
        project: { z: true },
      },
    },
  },
  {
    x: [thetaHistRidge[0][1]],
    y: [thetaHistRidge[0][0]],
    z: [thetaHistRidgeLoss[0]],
    text: thetaHistRidgeLoss.map(x => (x - 1000).toFixed(2)),
    hoverlabel: {
      font: { color: '#000' },
      bgcolor: colors[3],
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Ridge-MSE: %{text}<br>' + '<extra></extra>',
    showlegend: false,
    marker: {
      size: 12,
      color: colors[3],
      line: {
        color: 'rgba(217, 217, 217, 0.14)',
        width: 0.5,
      },
      opacity: 1,
    },
    line: {
      //size: 12,
      color: colors[3],
    },
    type: 'scatter3d',
    mode: `lines`,
  },
  {
    x: [thetaHistRidge[0][1]],
    y: [thetaHistRidge[0][0]],
    z: [thetaHistRidgeLoss[0]],
    text: [thetaHistRidgeLoss[0]].map(x => (x - 1000).toFixed(2)),
    hoverlabel: {
      font: { color: '#000' },
      bgcolor: colors[3],
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Ridge-MSE: %{text}<br>' + '<extra></extra>',
    showlegend: false,
    marker: {
      size: 12,
      color: colors[3],
      line: {
        color: 'rgba(217, 217, 217, 0.14)',
        width: 0.5,
      },
      opacity: 1,
    },
    line: {
      //size: 12,
      color: colors[3],
    },
    type: 'scatter3d',
    mode: `markers`,
  },
];

const lassoSubGDHist3dData = [
  {
    x: lassoRidgeM,
    y: lassoRidgeB,
    z: lassoLossZ,
    hoverlabel: {
      font: { color: '#fff' },
      bgcolor: '#17225D',
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Lasso-MSE: %{z}<br>' + '<extra></extra>',
    colorscale: 'YlGnBu',
    type: `surface`,
    contours: {
      z: {
        show: true,
        usecolormap: true,
        highlightcolor: `white`,
        project: { z: true },
      },
    },
  },
  {
    x: [thetaHistLassoSubGD[0][1]],
    y: [thetaHistLassoSubGD[0][0]],
    z: [thetaHistLassoLossSubGD[0]],
    hoverlabel: {
      font: { color: '#000' },
      bgcolor: colors[3],
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Lasso-MSE: %{z}<br>' + '<extra></extra>',
    showlegend: false,
    marker: {
      size: 12,
      color: colors[3],
      line: {
        color: 'rgba(217, 217, 217, 0.14)',
        width: 0.5,
      },
      opacity: 1,
    },
    line: {
      //size: 12,
      color: colors[3],
    },
    type: 'scatter3d',
    mode: `lines`,
  },
  {
    x: [thetaHistLassoSubGD[0][1]],
    y: [thetaHistLassoSubGD[0][0]],
    z: [thetaHistLassoLossSubGD[0]],
    text: [thetaHistLassoLossSubGD[0]].map(x => (x - 1000).toFixed(2)),
    hoverlabel: {
      font: { color: '#000' },
      bgcolor: colors[3],
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Lasso-MSE: %{text}<br>' + '<extra></extra>',
    showlegend: false,
    marker: {
      size: 12,
      color: colors[3],
      line: {
        color: 'rgba(217, 217, 217, 0.14)',
        width: 0.5,
      },
      opacity: 1,
    },
    line: {
      //size: 12,
      color: colors[3],
    },
    type: 'scatter3d',
    mode: `markers`,
  },
];

const lassoCDHist3dData = [
  {
    x: lassoRidgeM,
    y: lassoRidgeB,
    z: lassoLossZ,
    hoverlabel: {
      font: { color: '#fff' },
      bgcolor: '#17225D',
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Lasso-MSE: %{z}<br>' + '<extra></extra>',
    colorscale: 'YlGnBu',
    type: `surface`,
    contours: {
      z: {
        show: true,
        usecolormap: true,
        highlightcolor: `white`,
        project: { z: true },
      },
    },
  },
  {
    x: [thetaHistLassoCD[0][1]],
    y: [thetaHistLassoCD[0][0]],
    z: [thetaHistLassoLossCD[0]],
    hoverlabel: {
      font: { color: '#000' },
      bgcolor: colors[3],
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Lasso-MSE: %{z}<br>' + '<extra></extra>',
    showlegend: false,
    marker: {
      size: 12,
      color: colors[3],
      line: {
        color: 'rgba(217, 217, 217, 0.14)',
        width: 0.5,
      },
      opacity: 1,
    },
    line: {
      //size: 12,
      color: colors[3],
    },
    type: 'scatter3d',
    mode: `lines`,
  },
  {
    x: [thetaHistLassoCD[0][1]],
    y: [thetaHistLassoCD[0][0]],
    z: [thetaHistLassoLossCD[0]],
    text: [thetaHistLassoLossCD[0]].map(x => (x - 1000).toFixed(2)),
    hoverlabel: {
      font: { color: '#000' },
      bgcolor: colors[3],
    },
    hovertemplate: 'm: %{x}<br>' + 'b: %{y}<br>' + 'Lasso-MSE: %{text}<br>' + '<extra></extra>',
    showlegend: false,
    marker: {
      size: 12,
      color: colors[3],
      line: {
        color: 'rgba(217, 217, 217, 0.14)',
        width: 0.5,
      },
      opacity: 1,
    },
    line: {
      //size: 12,
      color: colors[3],
    },
    type: 'scatter3d',
    mode: `markers`,
  },
];

export const ridgeHistPlot = {
  data: ridgeHist3dData,
  style: { height: `30em` },
  props: {
    yAxisTitle: 'b',
    xAxisTitle: 'm',
    dragMode: '',
    scene: {
      xaxis: { title: 'm' },
      yaxis: { title: 'b' },
      zaxis: { title: 'Ridge-MSE' },
    },
    margin: { t: 20, r: 20, b: 20, l: 20 },
    changeDataFunctions: {
      'prev step': getCurrentStepAdjuster('Ridge', false),
      'next step': getCurrentStepAdjuster('Ridge', true),
    },
    metricInfo: {
      step: getCurrentRidgeStep,
    },
  },
};

export const lassoSubGDHistPlot = {
  data: lassoSubGDHist3dData,
  style: { height: `30em` },
  props: {
    yAxisTitle: 'b',
    xAxisTitle: 'm',
    dragMode: '',
    scene: {
      xaxis: { title: 'm' },
      yaxis: { title: 'b' },
      zaxis: { title: 'Lasso-MSE' },
    },
    margin: { t: 20, r: 20, b: 20, l: 20 },
    changeDataFunctions: {
      'prev step': getCurrentStepAdjuster('LassoSubGD', false),
      'next step': getCurrentStepAdjuster('LassoSubGD', true),
    },
    metricInfo: {
      step: getCurrentLassoStepSubGD,
    },
  },
};

export const lassoCDHistPlot = {
  data: lassoCDHist3dData,
  style: { height: `30em` },
  props: {
    yAxisTitle: 'b',
    xAxisTitle: 'm',
    dragMode: '',
    scene: {
      xaxis: { title: 'm' },
      yaxis: { title: 'b' },
      zaxis: { title: 'Lasso-MSE' },
    },
    margin: { t: 20, r: 20, b: 20, l: 20 },
    changeDataFunctions: {
      'prev step': getCurrentStepAdjuster('LassoCD', false),
      'next step': getCurrentStepAdjuster('LassoCD', true),
    },
    metricInfo: {
      step: getCurrentLassoStepCD,
    },
  },
};

export const absoluteFunctionBase = {
  data: [
    {
      x: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
      y: [5, 4, 3, 2, 1, 0, 1, 2, 3, 4, 5],
      type: `scatter`,
      mode: 'lines',
      name: '|x|',
      color: colors[0],
      hovertemplate: hoverTemplatePoint,
    },
  ],
  props: {
    xAxisTitle: 'x',
    yAxisTitle: 'y',
    plotTitle: 'absolute function',
  },
};

export const absoluteFunctionWithGrad = {
  data: [
    {
      x: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
      y: [5, 4, 3, 2, 1, 0, 1, 2, 3, 4, 5],
      type: `scatter`,
      mode: 'lines',
      name: '|x|',
      color: colors[0],
      hovertemplate: '<extra></extra>',
    },
    {
      x: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
      y: [5, 4, 3, 2, 1, 0, -1, -2, -3, -4, -5],
      type: `scatter`,
      mode: 'lines',
      name: 't(x = -0.5)',
      color: colors[1],
      hovertemplate: '<extra></extra>',
    },
    {
      x: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
      y: [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
      type: `scatter`,
      mode: 'lines',
      color: colors[2],
      name: 't(x = 0.5)',
      hovertemplate: '<extra></extra>',
    },
  ],
  props: {
    fixedRange: true,
    xRange: [-5, 5],
    yRange: [-5, 5],
  },
};

const absoluteFunctionSliderRange = [...Array(31).keys()].map(x => (x - 15) / 10); // [-0.5, -0.4, -0.3, -0.2, -0.1, 0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4, 1.5]
const absoluteFunctionXRange = [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5];

const absoluteFunctionSliderLayout = {
  transition: {
    duration: 750,
    easing: 'cubic-in-out',
  },
  xaxis: {
    range: [-5, 5],
    showgrid: true,
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  yaxis: {
    range: [-1, 5],
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  margin: { t: 80, r: 80, b: 80, l: 80 },
  paper_bgcolor: `rgba(0, 0, 0, 0)`,
  plot_bgcolor: `rgba(0, 0, 0, 0)`,
  font: {
    color: `rgba(255,255,255,0.5)`,
    size: 16,
  },
};

const absolutePlotBaseData = {
  x: absoluteFunctionXRange,
  y: absoluteFunctionXRange.map(x => Math.abs(x)),
  type: 'scatter',
  mode: 'lines',
  name: '|x|',
  color: colors[0],
  hovertemplate: hoverTemplatePoint,
};

export const absoluteFunctionSlider = {
  data: [
    absolutePlotBaseData,
    {
      x: absoluteFunctionXRange,
      y: absoluteFunctionXRange.map(x => x * -1.5),
      type: 'scatter',
      mode: 'lines',
      name: 'subgradient',
      'line.color': Math.abs(-1.5) <= 1 ? colors[1] : colors[3],
      hovertemplate: '<extra></extra>',
    },
  ],

  layout: absoluteFunctionSliderLayout,

  props: {
    xRange: [-5, 5],
    yRange: [-1, 1],
    fixedRange: true,
    sliderInfo: [
      {
        pad: { t: 30 },
        x: 0.05,
        len: 0.95,
        currentvalue: {
          xanchor: 'center',
          prefix: 'subgradient: ',
          font: {
            family: 'Inter',
            color: '#888',
            size: 20,
          },
        },
        transition: { duration: 0 },
        // By default, animate commands are bound to the most recently animated frame:
        steps: absoluteFunctionSliderRange.map(value => {
          return {
            label: value.toString(),
            method: 'animate',
            args: [
              [value.toString()],
              {
                mode: 'immediate',
                frame: { redraw: false, duration: 0 },
                transition: { duration: 0 },
              },
            ],
          };
        }),
      },
    ],
  },
  // The slider itself does not contain any notion of timing, so animating a slider
  // must be accomplished through a sequence of frames. Here we'll change the color
  // and the data of a single trace:
  frames: absoluteFunctionSliderRange.map(value => {
    return {
      name: value.toString(),
      data: [
        absolutePlotBaseData,
        {
          x: absoluteFunctionXRange,
          y: absoluteFunctionXRange.map(x => x * value),
          type: 'scatter',
          mode: 'lines',
          name: 'subgradient',
          'line.color': Math.abs(value) <= 1 ? colors[1] : colors[3],
        },
      ],
    };
  }),
};

const subgradientFixedData = {
  x: absoluteFunctionXRange,
  y: absoluteFunctionXRange.map(v => v * 0.2),
  color: colors[1],
  'line.color': colors[1],
  type: 'scatter',
  mode: 'lines',
  line: {
    color: colors[1],
  },
  hovertemplate: hoverTemplatePoint,
  name: 'g',
};

const absoluteFunctionSliderRangeExtended = [...Array(101).keys()].map(x => (x - 50) / 10); // [-5, -4.9, ..., 4.9, 5]

export const absoluteFunctionSubgradientConditionSlider = {
  data: [
    absolutePlotBaseData,
    subgradientFixedData,
    {
      x: [0.5],
      y: [0.5],
      type: 'scatter',
      mode: 'marker',
      hovertemplate: hoverTemplatePoint,
      marker: {
        color: colors[0],
        size: 20,
      },
      name: 'f(x)',
      'line.color': colors[0],
    },
    {
      x: [0.5],
      y: [0.5 * 0.2],
      type: 'scatter',
      mode: 'marker',
      hovertemplate: hoverTemplatePoint,
      marker: {
        color: colors[1],
        size: 20,
      },
      name: 'g(x)',
      'line.color': colors[1],
    },
  ],

  layout: absoluteFunctionSliderLayout,

  props: {
    xRange: [-5, 5],
    yRange: [-1, 1],
    fixedRange: true,
    sliderInfo: [
      {
        pad: { t: 30 },
        x: 0.05,
        len: 0.95,
        currentvalue: {
          xanchor: 'center',
          prefix: 'x: ',
          font: {
            family: 'Inter',
            color: '#888',
            size: 20,
          },
        },
        transition: { duration: 0 },
        // By default, animate commands are bound to the most recently animated frame:
        steps: absoluteFunctionSliderRangeExtended.map(value => {
          return {
            label: value.toString(),
            method: 'animate',
            args: [
              [value.toString()],
              {
                mode: 'immediate',
                frame: { redraw: false, duration: 0 },
                transition: { duration: 0 },
              },
            ],
          };
        }),
      },
    ],
  },
  // The slider itself does not contain any notion of timing, so animating a slider
  // must be accomplished through a sequence of frames. Here we'll change the color
  // and the data of a single trace:
  frames: absoluteFunctionSliderRangeExtended.map(value => {
    return {
      name: value.toString(),
      data: [
        absolutePlotBaseData,
        subgradientFixedData,
        {
          x: [value],
          y: [Math.abs(value)],
          type: 'scatter',
          mode: 'marker',
          hovertemplate: hoverTemplatePoint,
          marker: {
            color: colors[0],
            size: 20,
          },
          name: 'f(x)',
          'line.color': colors[0],
        },
        {
          x: [value],
          y: [value * 0.2],
          type: 'scatter',
          mode: 'marker',
          hovertemplate: hoverTemplatePoint,
          marker: {
            color: colors[1],
            size: 20,
          },
          name: 'g(x-x0)',
          'line.color': colors[1],
        },
      ],
    };
  }),
};

const getSubgradientDate = subgradientVal => {
  return {
    x: absoluteFunctionXRange,
    y: absoluteFunctionXRange.map(x => x * subgradientVal),
    color: colors[1],
    'line.color': colors[1],
    type: 'scatter',
    mode: 'lines',
    hovertemplate: hoverTemplatePoint,
    name: 'g',
  };
};

let subgradient = 0.2;

const getChangeSubgradient = inc => {
  const changeSubgradient = data => {
    subgradient = subgradient + inc ? 0.1 : -0.1;

    subgradient = parseFloat(subgradient.toFixed(1));

    let newSubgradient = getSubgradientDate(subgradient);

    const newData = [data[0], newSubgradient, data[2], data[3]];

    return newData;
  };
  return changeSubgradient;
};

const subgradientInteractiveLayout = {
  transition: {
    duration: 100,
    easing: 'cubic-in-out',
  },
  xaxis: {
    range: [-5, 5],
    showgrid: true,
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  yaxis: {
    range: [-1, 5],
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  margin: { t: 80, r: 80, b: 80, l: 80 },
  paper_bgcolor: `rgba(0, 0, 0, 0)`,
  plot_bgcolor: `rgba(0, 0, 0, 0)`,
  font: {
    color: `rgba(255,255,255,0.5)`,
    size: 16,
  },
};

export const absoluteFunctionSubgradientConditionSliderInteractive = {
  data: [
    absolutePlotBaseData,
    subgradientFixedData,
    {
      x: [0.5],
      y: [0.5],
      type: 'scatter',
      mode: 'marker',
      hovertemplate: hoverTemplatePoint,
      marker: {
        color: colors[0],
        size: 20,
      },
      name: 'f(x)',
      'line.color': colors[0],
    },
    {
      x: [0.5],
      y: [0.5 * 0.2],
      type: 'scatter',
      mode: 'marker',
      hovertemplate: hoverTemplatePoint,
      marker: {
        color: colors[1],
        size: 20,
      },
      name: 'g(x-x0)',
      'line.color': colors[1],
    },
  ],

  layout: subgradientInteractiveLayout,

  props: {
    xRange: [-5, 5],
    yRange: [-1, 1],
    fixedRange: true,

    changeDataFunctions: {
      'increase g': getChangeSubgradient(true),
      'decrease g': getChangeSubgradient(false),
    },
    metricInfo: {
      g: () => subgradient,
    },

    sliderInfo: [
      {
        pad: { t: 30 },
        x: 0.05,
        len: 0.95,
        currentvalue: {
          xanchor: 'center',
          prefix: 'x: ',
          font: {
            family: 'Inter',
            color: '#888',
            size: 20,
          },
        },
        transition: { duration: 0 },
        // By default, animate commands are bound to the most recently animated frame:
        steps: absoluteFunctionSliderRangeExtended.map(value => {
          return {
            label: value.toString(),
            method: 'animate',
            args: [
              [value.toString()],
              {
                mode: 'immediate',
                frame: { redraw: false, duration: 0 },
                transition: { duration: 0 },
              },
            ],
          };
        }),
      },
    ],
  },
  // The slider itself does not contain any notion of timing, so animating a slider
  // must be accomplished through a sequence of frames. Here we'll change the color
  // and the data of a single trace:
  frames: absoluteFunctionSliderRangeExtended.map(value => {
    return {
      name: value.toString(),
      data: [
        absolutePlotBaseData,
        subgradientFixedData,
        {
          x: [value],
          y: [Math.abs(value)],
          type: 'scatter',
          mode: 'marker',
          hovertemplate: hoverTemplatePoint,
          marker: {
            color: colors[0],
            size: 20,
          },
          name: 'f(x)',
          'line.color': colors[0],
        },
        {
          x: [value],
          y: [value * 0.2],
          type: 'scatter',
          mode: 'marker',
          hovertemplate: hoverTemplatePoint,
          marker: {
            color: colors[1],
            size: 20,
          },
          name: 'g(x-x0)',
          'line.color': colors[1],
        },
      ],
    };
  }),
};

// ----------------------------------------------------

const absoluteFunctionXRangeShifted = [
  -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
];

const absoluteFunctionSliderRangeShifted = [...Array(121).keys()].map(x => (x - 70) / 10); // [-7, -6.9, ..., 4.9, 5]

const absolutePlotBaseDataShifted = {
  x: absoluteFunctionXRangeShifted.map(x => x + 5),
  y: absoluteFunctionXRangeShifted.map(x => Math.abs(x)),
  type: 'scatter',
  mode: 'lines',
  name: 'f-',
  color: colors[0],
  hovertemplate: '<extra></extra>',
};

const subgradientFixedDataShifted = {
  x: absoluteFunctionXRangeShifted.map(x => x + 5),
  y: absoluteFunctionXRangeShifted.map(v => v * 0.2),
  color: colors[1],
  'line.color': colors[1],
  type: 'scatter',
  mode: 'lines',
  hovertemplate: hoverTemplatePoint,
  name: 'g-',
};

const absoluteFunctionSliderLayoutShifted = {
  transition: {
    duration: 750,
    easing: 'cubic-in-out',
  },
  xaxis: {
    range: [-2, 10],
    showgrid: true,
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  yaxis: {
    range: [-1, 10],
    gridcolor: 'rgba(255,255,255,0.05)',
    zeroline: true,
    fixedrange: true,
    showline: true,
    autotick: true,
    ticks: '',
    showticklabels: true,
  },
  margin: { t: 80, r: 80, b: 80, l: 80 },
  paper_bgcolor: `rgba(0, 0, 0, 0)`,
  plot_bgcolor: `rgba(0, 0, 0, 0)`,
  font: {
    color: `rgba(255,255,255,0.5)`,
    size: 16,
  },
};

export const absoluteFunctionSubgradientConditionSliderNonZero = {
  data: [
    absolutePlotBaseDataShifted,
    subgradientFixedDataShifted,
    {
      x: [3],
      y: [3],
      type: 'scatter',
      mode: 'marker',
      hovertemplate: hoverTemplatePoint,
      marker: {
        color: colors[0],
        size: 20,
      },
      name: 'f-(z)',
      'line.color': colors[0],
    },
    {
      x: [3],
      y: [(3 - 5) * 0.2],
      type: 'scatter',
      mode: 'marker',
      hovertemplate: hoverTemplatePoint,
      marker: {
        color: colors[1],
        size: 20,
      },
      name: '5 + g-(z-5)',
      'line.color': colors[1],
    },
  ],

  layout: absoluteFunctionSliderLayoutShifted,

  props: {
    xRange: [-5, 5],
    yRange: [-1, 1],
    fixedRange: true,
    sliderInfo: [
      {
        pad: { t: 30 },
        x: 0.05,
        len: 0.95,
        currentvalue: {
          xanchor: 'center',
          prefix: 'x: ',
          font: {
            family: 'Inter',
            color: '#888',
            size: 20,
          },
        },
        transition: { duration: 0 },
        // By default, animate commands are bound to the most recently animated frame:
        steps: absoluteFunctionSliderRangeShifted.map(value => {
          return {
            label: (value + 5).toFixed(1),
            method: 'animate',
            args: [
              [value.toString()],
              {
                mode: 'immediate',
                frame: { redraw: false, duration: 0 },
                transition: { duration: 0 },
              },
            ],
          };
        }),
      },
    ],
  },
  // The slider itself does not contain any notion of timing, so animating a slider
  // must be accomplished through a sequence of frames. Here we'll change the color
  // and the data of a single trace:
  frames: absoluteFunctionSliderRangeShifted.map(value => {
    return {
      name: value.toString(),
      data: [
        absolutePlotBaseDataShifted,
        subgradientFixedDataShifted,
        {
          x: [value + 5],
          y: [Math.abs(value)],
          type: 'scatter',
          mode: 'marker',
          hovertemplate: hoverTemplatePoint,
          marker: {
            color: colors[0],
            size: 20,
          },
          name: 'f(x)',
          'line.color': colors[0],
        },
        {
          x: [value + 5],
          y: [value * 0.2],
          type: 'scatter',
          mode: 'marker',
          hovertemplate: hoverTemplatePoint,
          marker: {
            color: colors[1],
            size: 20,
          },
          name: 'g(x-x0)',
          'line.color': colors[1],
        },
      ],
    };
  }),
};
